import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SectionImagemContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getImagem(id: string): Observable<any> {
    return this.getImagemContents(id).pipe(
      map(res => this.buildResponseImagemObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryImagemContents[0].flatData;
  }

  private getImagemContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryImagemContents(filter: "id eq '${id}'") {
          flatData {
            nome
            imagem {
              url
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseImagemObject(data: any) {
    return {
      image: data.imagem && data.imagem[0]
        ? data.imagem[0].url
        : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

}
